export default {
    "pages": {
        "titles": "Páginas",
        "title": "Página",
        "list": {
            "title": "@:pages.model.title",
            "type": "@:pages.model.type",
            "published": "@:pages.model.published",
            "order": "@:pages.model.order",
            "footer": "@:pages.model.footer",
            "slug": "Slug",
        },
        "model": {
            "title": "Título",
            "type": "Tipo",
            "content": "Conteúdo",
            "published": "Publicado",
            "url": "URL",
            "footer": "Rodapé",
            "order": "Ordem",
        },
        "help": {
            "title": "Título da página.",
            "type": "Tipo da página.",
            "published": "Permite publicar a página no frontend do portal.",
            "url": "Definir o endereço para uma página externa (Caso seja definido, o conteúdo será ignorado).",
            "content": "Conteúdo da página.",
            "footer": "Permite que a página apareça como link no rodapé no frontend do portal."
        }
    },
    "news": {
        "titles": "Notícias",
        "title": "Notícia",
        "list": {
            "title": "@:news.model.title",
            "subtitle": "@:news.model.subtitle",
            "category": "@:news.model.category",
            "published": "@:news.model.published",
            "published_at": "@:news.model.published_at",
            "order": "@:pages.model.order",
            "slug": "Slug",
        },
        "model": {
            "title": "Título",
            "subtitle": "Resumo",
            "content": "Conteúdo",
            "thumbnail": "Capa",
            "published": "Publicado",
            "published_at": "Publicado em",
            "locale": "Língua",
            "news": "Tradução da notícia",
            "category": "Categoria",
            "order": "Ordem",
            "roles": "Perfis de Acesso",
        },
        "help": {
            "title": "Título da notícia",
            "subtitle": "Breve resumo da notícia",
            "content": "Conteúdo da notícia",
            "published": "Permite publicar a notícia no frontend do portal",
            "locale": "Língua traduzida",
            "news": "Vincular a tradução da notícia selecionada",
            "category": "Categoria da notícia",
            "order": "Ordem de apresentação",
            "roles": "Perfil de acesso à noticia, por defeito é publico.",
        }
    },
    "news_categories": {
        "titles": "Categorias",
        "title": "Categoria",
        "model": {
            "name": "Nome",
            "description": "Descrição",
            "slug": "Slug",
            "locale": "Língua",
            "roles": "Perfis de Acesso",
        },
        "list": {
            "name": "@:news_categories.model.name",
            "description": "@:news_categories.model.description",
            "slug": "@:news_categories.model.slug",
            "locale": "@:news_categories.model.locale",
        },
        "help": {
            "name": "Nome da categoria",
            "description": "Breve descrição da categoria",
            "slug": "Slug",
            "locale": "Língua traduzida",
            "roles": "Perfil de acesso à categoria, por defeito é publico.",
        }
    },
    "global_settings": {
        "home": {
            "divider": "Página Inicial",
            "title": "Descrição da Plataforma",
            "news_title": "Título das notícias",
            "news_slider": "Nº de notícias no slider",
            "news_order": "Posição das notícias na página",
            "modules_title": "Título dos módulos",
            "modules_limit": "Nº de módulos em destaque",
            "modules_order": "Posição dos módulos na página",
        },
        "news": {
            "divider": "Página de Notícias",
            "title": "Título da listagem de notícias",
            "per_page": "Notícias por página",
        }
    }
}
